/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cards from 'react-credit-cards';
import { getTranslation } from 'ggApp/utils/text';
import 'react-credit-cards/lib/styles-compiled.css';

import { LayoutComponent_Text as Text } from 'ggApp/modules/layout';

import AdyenFormCreditCard from 'ggApp/shared/forms/adyen/creditCard';

import styles from './index.module.scss';

class AdyenCardForm extends Component {
    static contextTypes = {
        store: PropTypes.shape({}),
    };

    constructor(props) {
        super(props);

        this.state = {
            focus: 'number',
        };
    }

    setFocusField = (fieldName) => {
        this.setState({
            focus: fieldName,
        });
    };

    render() {
        const { showCard, formValues, onSubmit, adyenSubmittedPayment, dark } = this.props;
        const { focus } = this.state;
        const { store } = this.context;
        return (
            <div
                className={`${styles.adyenFormUiComponent} ${
                    dark ? styles['adyenFormUiComponent--dark'] : ''
                }`}
            >
                <div className={styles.adyenFormUiComponent__box}>
                    <div>
                        {showCard && (
                            <div>
                                <Cards
                                    number={formValues.number.replace(/\s/g, '')}
                                    name={formValues.name}
                                    expiry={formValues.expiry.replace(/\s/g, '')}
                                    cvc={formValues.cvc.replace(/\s/g, '')}
                                    focused={focus}
                                    locale={{
                                        valid: getTranslation(
                                            store,
                                            'FORM_LABEL_CC_VALID_THRU_MINI',
                                        ),
                                    }}
                                    placeholders={{
                                        name: getTranslation(store, 'FORM_LABEL_CC_HOLDER_NAME'),
                                    }}
                                />
                            </div>
                        )}

                        <AdyenFormCreditCard
                            callback={onSubmit}
                            loading={adyenSubmittedPayment && adyenSubmittedPayment.loading}
                            setFocusField={this.setFocusField}
                        />
                    </div>
                </div>
                {adyenSubmittedPayment && adyenSubmittedPayment.error.base && (
                    <Text error>
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: adyenSubmittedPayment.error.base,
                            }}
                        />
                    </Text>
                )}
            </div>
        );
    }
}

export default AdyenCardForm;
